import {
  Button,
  Checkbox,
  Grid,
  ListItemText,
  MenuItem,
  Select,
  Typography,
} from '@mui/material'
import { Form } from '../../UI/Form'
import { styled } from '@mui/system'
import { Calculate } from '@mui/icons-material'
import { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import {
  getRetencionesById,
  getSelectBonos,
  getWorkersByArea,
  selectSalesWorkers,
} from '../../../helpers/workersFunctions'
import {
  calculateSalesSalaries,
  checkStatus,
  getComisionsLogisticWorker,
  getStatus,
} from '../../../helpers/nominaFunctions'
import { createSalesNomina } from '../../../services/nomina'
import { salesReport } from '../../../services/reports'

const Subtitle = styled((props) => <Typography {...props} />)(() => ({
  fontFamily: 'Nunito',
  fontWeight: '600',
  fontSize: '1.2rem',
  marginBottom: '2vh',
  display: 'flex',
  justifyContent: 'center',
}))

const NormalText = styled((props) => <Typography {...props} />)(() => ({
  fontFamily: 'Nunito',
  fontWeight: '500',
  fontSize: '1rem',
  marginBottom: '2vh',
  display: 'flex',
  justifyContent: 'center',
}))

const GenerateButton = styled((props) => <Button {...props} />)(() => ({
  backgroundColor: 'orange',
  border: '1px solid darkorange',
  padding: '12px 15px',
  height: '40px',
  fontSize: '1em',
  borderRadius: '30px',
  transition: '0.3s all ease',
  color: 'white',
  width: '100%',
  '&:hover': {
    backgroundColor: 'darkorange',
    border: '1px solid orange',
  },
  marginTop: '10px',
  marginBottom: '15px',
}))

const BonoSelect = styled((props) => <Select {...props} />)(() => ({
  width: '100%',
  backgroundColor: '#e9e9e9',
  borderRadius: '20px',
  height: '38px',
  border: '1px solid rgba(201, 201, 201, 0.711)',
  paddingLeft: '20px',
  fontSize: '14px',
  fontFamily: 'Nunito',
  '&:focus': {
    backgroundColor: 'transparent', // Esto elimina el color de fondo cuando está seleccionado
    border: 'none', // También puedes eliminar el borde si es necesario
  },
}))

const ReportButton = styled((props) => <Button {...props} />)(() => ({
  backgroundColor: '#00544e',
  border: '1px solid #009696',
  padding: '12px 15px',
  height: '40px',
  fontSize: '1em',
  borderRadius: '30px',
  transition: '0.3s all ease',
  color: 'white',
  width: '100%',
  '&:hover': {
    backgroundColor: '#009696',
    border: '1px solid #00544e',
  },
  marginTop: '10px',
  marginBottom: '15px',
}))

const trabajador = {
  diasLaborados: 0,
  horasExtra: 0,
  salarioSemanal: '',
  salarioNeto: '',
  trabajador: {
    id: '',
    nombre: '',
  },
  bonos: [],
  comisiones: '',
  comisionesObj: {
    cpc30r: '',
    cpc30r2: '',
    mort: '',
    mort2: '',
    var38: '',
    block: '',
    tabicon: '',
    poste2: '',
    poste25: '',
  },
  importes: {
    sueldoDiario: '',
    cpc30r: '',
    cpc30r2: '',
    mort: '',
    mort2: '',
    var38: '',
    block: '',
    tabicon: '',
    poste2: '',
    poste25: '',
    bonos: [],
    retencion: '',
  },
}

const objectArea = {
  comisiones: {
    cpc30r: '',
    mort: '',
    var38: '',
    block: '',
    tabicon: '',
    poste2: '',
    poste25: '',
  },
}

const SalesForm = ({ setObject, object, setOpenPopup, setId, id }) => {
  let workers = []

  const [tempObject, setTempObject] = useState({
    //...objectArea,
    vendedores: [],
  })
  const [status, setStatus] = useState(false)
  const [objComisiones, setObjComisiones] = useState(false)

  useEffect(() => {
    setStatus(checkStatus(getStatus(id)))

    workers = getWorkersByArea('5')

    if (object?.comisiones) {
      setObjComisiones(true)
    }

    setTempObject((prev) => ({
      ...prev,
      ...(object || {}),
      vendedores:
        Array.isArray(object?.vendedores) && object.vendedores.length > 0
          ? object.vendedores
          : workers.map((worker) => ({
            ...trabajador,
            trabajador: {
              id: worker.id,
              nombre: worker.nombre,
            },
          })),
    }))
  }, [object, objComisiones])

  const resetData = () => {
    setId('')
    setObject(object)
  }

  const handleGenerateSalary = (workerData, index) => {
    try {
      // 1. Validaciones previas para asegurar que `workerData` es válido
      if (!workerData || !workerData.trabajador || !workerData.trabajador.id) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Datos del trabajador incompletos o inválidos.',
        })
        return
      }

      // Validación de que `id` está presente
      if (!id) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'ID de la nómina no disponible.',
        })
        return
      }

      // Crear una copia profunda de `workerData` para evitar referencias compartidas
      const workerDataCopy = JSON.parse(JSON.stringify(workerData))

      // 2. Llamada a `calculateDriverSalaries` con `workerData` e `id`
      const updatedWorkerData = calculateSalesSalaries(
        workerDataCopy,
        workerDataCopy.comisionesObj
      )

      // Validación de que `calculateDriverSalaries` ha retornado datos válidos
      if (
        !updatedWorkerData ||
        typeof updatedWorkerData.salarioSemanal === 'undefined'
      ) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error en el cálculo del salario. Intenta nuevamente.',
        })
        return
      }

      setTempObject((prevTempObject) => {
        if (!prevTempObject.vendedores[index]) {
          console.error('El índice no existe en vendedores:', index)
          return prevTempObject // Evitar cambios si el índice no existe
        }

        return {
          ...prevTempObject,
          vendedores: {
            ...prevTempObject.vendedores,
            [index]: {
              ...prevTempObject.vendedores[index],
              ...updatedWorkerData,
            },
          },
        }
      })

      // Mensaje de éxito si todo ha salido bien
      Swal.fire({
        icon: 'success',
        title: 'Salario Generado',
        text: `Salario calculado exitosamente para ${workerData.trabajador.nombre}.`,
      })
    } catch (error) {
      // 4. Manejo de errores
      Swal.fire({
        icon: 'error',
        title: 'Error inesperado',
        text: `Ocurrió un error: ${error.message}.`,
      })
      console.error('Error en handleGenerateSalary:', error)
    }
    workerData = null
  }

  const handleGenerateReport = () => {
    salesReport(tempObject, id)
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!objComisiones) {
      createSalesNomina(tempObject, id)

      resetData()
      Swal.fire('Hecho', 'Area actualizada con éxito', 'success')
    } else {
      Swal.fire('No se puede realizar esta acción', 'El registro cuenta con una estructura desactualizada en la información', 'error')
    }
    setObjComisiones(false)
    setOpenPopup(false)
  }

  return (
    <div
      style={{
        justifyContent: 'center',
        display: 'flex',
        marginBottom: '10px',
        width: '100%',
      }}
    >
      <Form style={{ width: '100%' }} onSubmit={handleSubmit}>
        <Grid container spacing={1}>
          <Grid item container spacing={1}>
            {objComisiones ? (
              <><Grid item md={12}>
                <Subtitle>Comisiones Semanales</Subtitle>
              </Grid>
                <Grid container item md={12}>
                  <Grid item md={1}>
                    <NormalText>Cemento</NormalText>
                  </Grid>
                  <Grid item md={3}>
                    <input
                      className="input-select"
                      name={`cpc30r`}
                      type="number"
                      min={0}
                      value={tempObject.comisiones.cpc30r}
                      onChange={(e) => {
                        // Actualiza el estado aquí con el nuevo valor
                        const newValue = e.target.value
                        setTempObject((prevState) => ({
                          ...prevState,
                          comisiones: {
                            ...prevState.comisiones,
                            cpc30r: newValue,
                          },
                        }))
                      }}
                      disabled={status}
                    />
                  </Grid>

                  <Grid item md={1}>
                    <NormalText>Mortero</NormalText>
                  </Grid>
                  <Grid item md={3}>
                    <input
                      className="input-select"
                      name={`mort`}
                      type="number"
                      min={0}
                      value={tempObject.comisiones.mort}
                      onChange={(e) => {
                        // Actualiza el estado aquí con el nuevo valor
                        const newValue = e.target.value
                        setTempObject((prevState) => ({
                          ...prevState,
                          comisiones: {
                            ...prevState.comisiones,
                            mort: newValue,
                          },
                        }))
                      }}
                      disabled={status}
                    />
                  </Grid>

                  <Grid item md={1}>
                    <NormalText>Varilla 3/8</NormalText>
                  </Grid>
                  <Grid item md={3}>
                    <input
                      className="input-select"
                      name={`var38`}
                      type="number"
                      min={0}
                      value={tempObject.comisiones.var38}
                      onChange={(e) => {
                        // Actualiza el estado aquí con el nuevo valor
                        const newValue = e.target.value
                        setTempObject((prevState) => ({
                          ...prevState,
                          comisiones: {
                            ...prevState.comisiones,
                            var38: newValue,
                          },
                        }))
                      }}
                      disabled={status}
                    />
                  </Grid>

                  <Grid item md={1}>
                    <NormalText>Block</NormalText>
                  </Grid>
                  <Grid item md={2}>
                    <input
                      className="input-select"
                      name={`block`}
                      type="number"
                      min={0}
                      value={tempObject.comisiones.block}
                      onChange={(e) => {
                        // Actualiza el estado aquí con el nuevo valor
                        const newValue = e.target.value
                        setTempObject((prevState) => ({
                          ...prevState,
                          comisiones: {
                            ...prevState.comisiones,
                            block: newValue,
                          },
                        }))
                      }}
                      disabled={status}
                    />
                  </Grid>

                  <Grid item md={1}>
                    <NormalText>Tabicon</NormalText>
                  </Grid>
                  <Grid item md={2}>
                    <input
                      className="input-select"
                      name={`tabicon`}
                      type="number"
                      min={0}
                      value={tempObject.comisiones.tabicon}
                      onChange={(e) => {
                        // Actualiza el estado aquí con el nuevo valor
                        const newValue = e.target.value
                        setTempObject((prevState) => ({
                          ...prevState,
                          comisiones: {
                            ...prevState.comisiones,
                            tabicon: newValue,
                          },
                        }))
                      }}
                      disabled={status}
                    />
                  </Grid>

                  <Grid item md={1}>
                    <NormalText>Poste 2M</NormalText>
                  </Grid>
                  <Grid item md={2}>
                    <input
                      className="input-select"
                      name={`poste2`}
                      type="number"
                      min={0}
                      value={tempObject.comisiones.poste2}
                      onChange={(e) => {
                        // Actualiza el estado aquí con el nuevo valor
                        const newValue = e.target.value
                        setTempObject((prevState) => ({
                          ...prevState,
                          comisiones: {
                            ...prevState.comisiones,
                            poste2: newValue,
                          },
                        }))
                      }}
                      disabled={status}
                    />
                  </Grid>

                  <Grid item md={1}>
                    <NormalText>Poste 2.5M</NormalText>
                  </Grid>
                  <Grid item md={2}>
                    <input
                      className="input-select"
                      name={`poste25`}
                      type="number"
                      min={0}
                      value={tempObject.comisiones.poste25}
                      onChange={(e) => {
                        // Actualiza el estado aquí con el nuevo valor
                        const newValue = e.target.value
                        setTempObject((prevState) => ({
                          ...prevState,
                          comisiones: {
                            ...prevState.comisiones,
                            poste25: newValue,
                          },
                        }))
                      }}
                      disabled={status}
                    />
                  </Grid>
                </Grid></>
            ) : null}

          </Grid>
          {Object.values(tempObject.vendedores).map((worker, index) => (
            <Grid container item md={12} spacing={1} key={worker.trabajador.id}>
              <Grid item md={12}>
                <Subtitle>Vendedor {worker.trabajador.nombre}</Subtitle>
              </Grid> 

              {!objComisiones ? (
                <><Grid item md={12}>
                  <Subtitle>Comisiones Semanales</Subtitle>
                </Grid>
                  <Grid container item md={12}>
                    <Grid item md={1}>
                      <NormalText>Cemento Rango 1</NormalText>
                    </Grid>
                    <Grid item md={3}>
                      <input
                        className="input-select"
                        name={`cpc30r`}
                        type="number"
                        min={0}
                        value={worker.comisionesObj?.cpc30r}
                        onChange={(e) => {
                          // Actualiza el estado aquí con el nuevo valor
                          const newValue = e.target.value
                          setTempObject(prevState => ({
                            ...prevState,
                            vendedores: {
                              ...prevState.vendedores,
                              [index]: {
                                ...prevState.vendedores[index],
                                comisionesObj: {
                                  ...prevState.vendedores[index].comisionesObj,
                                  cpc30r: newValue,
                                }
                              },
                            },
                          }))
                        }}
                        disabled={status}
                      />
                    </Grid>

                    <Grid item md={1}>
                      <NormalText>Cemento Rango 2</NormalText>
                    </Grid>
                    <Grid item md={3}>
                      <input
                        className="input-select"
                        name={`cpc30r2`}
                        type="number"
                        min={0}
                        value={worker.comisionesObj?.cpc30r2}
                        onChange={(e) => {
                          // Actualiza el estado aquí con el nuevo valor
                          const newValue = e.target.value
                          setTempObject(prevState => ({
                            ...prevState,
                            vendedores: {
                              ...prevState.vendedores,
                              [index]: {
                                ...prevState.vendedores[index],
                                comisionesObj: {
                                  ...prevState.vendedores[index].comisionesObj,
                                  cpc30r2: newValue,
                                }
                              },
                            },
                          }))
                        }}
                        disabled={status}
                      />
                    </Grid>

                    <Grid item md={1}>
                      <NormalText>Mortero</NormalText>
                    </Grid>
                    <Grid item md={3}>
                      <input
                        className="input-select"
                        name={`mort`}
                        type="number"
                        min={0}
                        value={worker.comisionesObj?.mort}
                        onChange={(e) => {
                          // Actualiza el estado aquí con el nuevo valor
                          const newValue = e.target.value
                          setTempObject(prevState => ({
                            ...prevState,
                            vendedores: {
                              ...prevState.vendedores,
                              [index]: {
                                ...prevState.vendedores[index],
                                comisionesObj: {
                                  ...prevState.vendedores[index].comisionesObj,
                                  mort: newValue,
                                }
                              },
                            },
                          }))
                        }}
                        disabled={status}
                      />
                    </Grid>

                    <Grid item md={1}>
                      <NormalText>Mortero Rango 2</NormalText>
                    </Grid>
                    <Grid item md={3}>
                      <input
                        className="input-select"
                        name={`mort2`}
                        type="number"
                        min={0}
                        value={worker.comisionesObj?.mort2}
                        onChange={(e) => {
                          // Actualiza el estado aquí con el nuevo valor
                          const newValue = e.target.value
                          setTempObject(prevState => ({
                            ...prevState,
                            vendedores: {
                              ...prevState.vendedores,
                              [index]: {
                                ...prevState.vendedores[index],
                                comisionesObj: {
                                  ...prevState.vendedores[index].comisionesObj,
                                  mort2: newValue,
                                }
                              },
                            },
                          }))
                        }}
                        disabled={status}
                      />
                    </Grid>

                    <Grid item md={1}>
                      <NormalText>Varilla 3/8</NormalText>
                    </Grid>
                    <Grid item md={3}>
                      <input
                        className="input-select"
                        name={`var38`}
                        type="number"
                        min={0}
                        value={worker.comisionesObj?.var38}
                        onChange={(e) => {
                          // Actualiza el estado aquí con el nuevo valor
                          const newValue = e.target.value
                          setTempObject(prevState => ({
                            ...prevState,
                            vendedores: {
                              ...prevState.vendedores,
                              [index]: {
                                ...prevState.vendedores[index],
                                comisionesObj: {
                                  ...prevState.vendedores[index].comisionesObj,
                                  var38: newValue,
                                }
                              },
                            },
                          }))
                        }}
                        disabled={status}
                      />
                    </Grid>

                    <Grid item md={1}>
                      <NormalText>Block</NormalText>
                    </Grid>
                    <Grid item md={3}>
                      <input
                        className="input-select"
                        name={`block`}
                        type="number"
                        min={0}
                        value={worker.comisionesObj?.block}
                        onChange={(e) => {
                          // Actualiza el estado aquí con el nuevo valor
                          const newValue = e.target.value
                          setTempObject(prevState => ({
                            ...prevState,
                            vendedores: {
                              ...prevState.vendedores,
                              [index]: {
                                ...prevState.vendedores[index],
                                comisionesObj: {
                                  ...prevState.vendedores[index].comisionesObj,
                                  block: newValue,
                                }
                              },
                            },
                          }))
                        }}
                        disabled={status}
                      />
                    </Grid>

                    <Grid item md={1}>
                      <NormalText>Tabicon</NormalText>
                    </Grid>
                    <Grid item md={3}>
                      <input
                        className="input-select"
                        name={`tabicon`}
                        type="number"
                        min={0}
                        value={worker.comisionesObj?.tabicon}
                        onChange={(e) => {
                          // Actualiza el estado aquí con el nuevo valor
                          const newValue = e.target.value
                          setTempObject(prevState => ({
                            ...prevState,
                            vendedores: {
                              ...prevState.vendedores,
                              [index]: {
                                ...prevState.vendedores[index],
                                comisionesObj: {
                                  ...prevState.vendedores[index].comisionesObj,
                                  tabicon: newValue,
                                }
                              },
                            },
                          }))
                        }}
                        disabled={status}
                      />
                    </Grid>

                    <Grid item md={1}>
                      <NormalText>Poste 2M</NormalText>
                    </Grid>
                    <Grid item md={3}>
                      <input
                        className="input-select"
                        name={`poste2`}
                        type="number"
                        min={0}
                        value={worker.comisionesObj?.poste2}
                        onChange={(e) => {
                          // Actualiza el estado aquí con el nuevo valor
                          const newValue = e.target.value
                          setTempObject(prevState => ({
                            ...prevState,
                            vendedores: {
                              ...prevState.vendedores,
                              [index]: {
                                ...prevState.vendedores[index],
                                comisionesObj: {
                                  ...prevState.vendedores[index].comisionesObj,
                                  poste2: newValue,
                                }
                              },
                            },
                          }))
                        }}
                        disabled={status}
                      />
                    </Grid>

                    <Grid item md={1}>
                      <NormalText>Poste 2.5M</NormalText>
                    </Grid>
                    <Grid item md={3}>
                      <input
                        className="input-select"
                        name={`poste25`}
                        type="number"
                        min={0}
                        value={worker.comisionesObj?.poste25}
                        onChange={(e) => {
                          // Actualiza el estado aquí con el nuevo valor
                          const newValue = e.target.value
                          setTempObject(prevState => ({
                            ...prevState,
                            vendedores: {
                              ...prevState.vendedores,
                              [index]: {
                                ...prevState.vendedores[index],
                                comisionesObj: {
                                  ...prevState.vendedores[index].comisionesObj,
                                  poste25: newValue,
                                }
                              },
                            },
                          }))
                        }}
                        disabled={status}
                      />
                    </Grid>
                  </Grid></>
              ) : null}

              <Grid item md={1}>
                <NormalText>Días Laborados</NormalText>
              </Grid>
              <Grid item md={3}>
                <input
                  className="input-select"
                  name={`diasLaborados-${index}`}
                  type="number"
                  min={0}
                  max={6}
                  value={worker.diasLaborados}
                  onChange={(e) => {
                    const newValue = e.target.value

                    setTempObject((prevState) => ({
                      ...prevState,
                      vendedores: {
                        ...prevState.vendedores,
                        [index]: {
                          ...prevState.vendedores[index],
                          diasLaborados: newValue, // Se actualiza solo este campo sin afectar otros datos
                        },
                      },
                    }))
                  }}
                  disabled={status}
                />
              </Grid>

              <Grid item md={1}>
                <NormalText>Horas Extra</NormalText>
              </Grid>
              <Grid item md={3}>
                <input
                  className="input-select"
                  name={`horasExtra-${index}`}
                  type="number"
                  max={10}
                  value={worker.horasExtra || 0}
                  onChange={(e) => {
                    const newValue = e.target.value

                    setTempObject((prevState) => ({
                      ...prevState,
                      vendedores: {
                        ...prevState.vendedores,
                        [index]: {
                          ...prevState.vendedores[index],
                          horasExtra: newValue, // Se actualiza correctamente sin afectar los bonos
                        },
                      },
                    }))
                  }}
                  disabled={status}
                />
              </Grid>

              <Grid item md={1}>
                <NormalText>Bonos</NormalText>
              </Grid>
              <Grid item md={3}>
                <BonoSelect
                  name={`bonos-${index}`}
                  multiple
                  value={worker.bonos || []}
                  onChange={(e) => {
                    const { value } = e.target
                    const newValue =
                      typeof value === 'string' ? value.split(',') : value //Asegurar array

                    setTempObject((prevState) => {
                      const workerId = worker.trabajador.id

                      //Mapea los bonos para crear objetos
                      const updatedBonos = newValue.map((bono) => ({
                        bono: bono,
                        importe: Number(
                          getComisionsLogisticWorker(
                            workerId,
                            1,
                            bono.toLowerCase()
                          )
                        ),
                      }))

                      // Crear un nuevo objeto vendedores sin perder la estructura
                      const updatedVendedores = {
                        ...prevState.vendedores,
                        [index]: {
                          ...prevState.vendedores[index],
                          bonos: newValue,
                          importes: { bonos: updatedBonos },
                        },
                      }

                      return {
                        ...prevState,
                        vendedores: updatedVendedores,
                      }
                    })
                  }}
                  disabled={status}
                  renderValue={(selected) => selected.join(', ')}
                >
                  {getSelectBonos(worker.trabajador.id).map((item) => (
                    <MenuItem key={item.id} value={item.title}>
                      <Checkbox
                        checked={
                          Array.isArray(worker.bonos) &&
                          worker.bonos.indexOf(item.title) > -1
                        }
                      />
                      <ListItemText primary={item.title} />
                    </MenuItem>
                  ))}
                </BonoSelect>
              </Grid>

              {/* Salarios */}
              <Grid container item md={12}>
                {/** */}
                <Grid item md={6} />
                <Grid item md={3}>
                  <NormalText>Salario Semanal Sin Comisiones</NormalText>
                </Grid>
                <Grid item md={1}>
                  <NormalText>=</NormalText>
                </Grid>
                <Grid item md={2}>
                  <NormalText onClick={() => console.log(tempObject)}>
                    $
                    {(worker.salarioSemanal - worker.comisiones).toFixed(2) ||
                      '0.00'}
                  </NormalText>
                </Grid>
                {/** */}
                <Grid item md={6} />
                <Grid item md={3}>
                  <NormalText>Comisiones Semanales</NormalText>
                </Grid>
                <Grid item md={1}>
                  <NormalText>=</NormalText>
                </Grid>
                <Grid item md={2}>
                  <NormalText>
                    $+{Number(worker.comisiones).toFixed(2) || '0.00'}
                  </NormalText>
                </Grid>
                {/** */}
                <Grid item md={6} />
                <Grid item md={3}>
                  <NormalText>Salario Semanal Con Comisiones</NormalText>
                </Grid>
                <Grid item md={1}>
                  <NormalText>=</NormalText>
                </Grid>
                <Grid item md={2}>
                  <NormalText>
                    ${Number(worker.salarioSemanal).toFixed(2) || '0.00'}
                  </NormalText>
                </Grid>
                {/** */}
                <Grid item md={6} />
                <Grid item md={3}>
                  <NormalText>Retenciones</NormalText>
                </Grid>
                <Grid item md={1}>
                  <NormalText>=</NormalText>
                </Grid>
                <Grid item md={2}>
                  <NormalText>
                    $-
                    {(
                      Number(worker.salarioSemanal) - Number(worker.salarioNeto)
                    ).toFixed(2) || '0.00'}
                  </NormalText>
                </Grid>
                {/** */}
                <Grid item md={6} />
                <Grid item md={3}>
                  <NormalText>Salario Semanal Neto</NormalText>
                </Grid>
                <Grid item md={1}>
                  <NormalText>=</NormalText>
                </Grid>
                <Grid item md={2}>
                  <NormalText>
                    ${Number(worker.salarioNeto).toFixed(2) || '0.00'}
                  </NormalText>
                </Grid>
              </Grid>

              <Grid item md={8} />
              <Grid item md={4}>
                <GenerateButton
                  variant="contained"
                  startIcon={<Calculate />}
                  onClick={() => {
                    handleGenerateSalary(worker, index)
                  }}
                  disabled={status}
                >
                  Generar Salario
                </GenerateButton>
              </Grid>
            </Grid>
          ))}
        </Grid>
        {!status ? (
          <input
            id="submit"
            className="btn"
            type="submit"
            name="submit"
            disabled={status}
          />
        ) : (
          <Grid container spacing={1}>
            <Grid item md={12} onClick={() => handleGenerateReport()}>
              <ReportButton>Generar Reporte General de Area</ReportButton>
            </Grid>
          </Grid>
        )}
      </Form>
    </div>
  )
}

export default SalesForm
